export const LANGUAGES = [
    'Albanian',
    'American Sign Language',
    'Arabic',
    'Aramaic',
    'Cantonese',
    'Creole',
    'Croatian',
    'English',
    'Eritrean',
    'Filipino',
    'French',
    'German',
    'Ghanian',
    'Haitian',
    'Hungarian',
    'Indonesian',
    'Italian',
    'Korean',
    'Latin',
    'Lithuanian',
    'Mandarin',
    'Polish',
    'Portuguese',
    'Slovak',
    'Spanish',
    'Ukrainian',
    'Vietnamese',
];
